import { Dropdown } from "@swivl-mono/ui"
import VarsModel from "../../../Models/Variables/VarsModel.Model"

interface Props {
  prependOptions?: any[]
  skipUserId?: boolean
  skipLastUserInput?: boolean
  addMarkup?: boolean
  includeURLPath?: boolean
  skipBotVariables?: boolean
  value?: string
  name?: string
  onChange?: any
}

export default function UserVariablesDropdown(props: Props) {
  let options = (props.prependOptions) ? props.prependOptions : [];
  const uvVariables = VarsModel.variableOptions(props.skipUserId, props.skipLastUserInput, props.addMarkup, props.includeURLPath, props.skipBotVariables)
  options = options.concat(uvVariables)
  const value = props.value?.replace("#*", "").replace("*#", "")

  return <Dropdown options={options} value={value} name={props.name} onChange={props.onChange} showSearch={true} />;
}
